<template>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 1600 1600"
		style="enable-background:new 0 0 1600 1600;"
		xml:space="preserve"
	>
		<g id="Noodles">
			<g>
				<path
					class="st5"
					d="M884.9,1592.1c-0.3-15.8,1.1-31.4,2.7-46.9c1.5-14.5,3.6-28.9,5.4-43.3c0.6-5,1.2-9.9,1.7-14.9
                    c0.9-9.5,2-18.9,2.6-28.4c0.5-7.3,1-14.7,0.2-21.8c-1.3-11.9-3.9-23.5-5.7-35.4c-2.1-14.2-7.1-27.4-11.1-40.9
                    c-2-6.8-3.9-13.7-4.9-20.6c-0.8-5.1-0.4-10.5,0.1-15.6c1.2-14,4.7-27.5,9.3-40.7c3.5-10,7-19.9,9.9-30c1.7-6,2.4-12.4,3.5-18.7
                    c3.9-21.8,1.1-43.2-4.5-64.3c-3-11.3-6.9-22.4-10.3-33.6c-4.5-14.7-9.5-29.3-13.1-44.3c-4.5-19.1-6.8-38.6-5.6-58.4
                    c0.9-14,1.6-28,3.1-41.9c1-9.4,2.3-18.9,5.5-27.9c2-5.7,2.7-12,4.3-17.9c1.8-6.8,3.6-13.7,6-20.2c5.4-14.4,10.4-29,14.1-44
                    c3.8-15.2,5.7-30.8,4.8-46.5c-0.9-14.9-2.8-29.7-6.7-44.1c-1.8-6.6-4.2-13.1-5.9-19.7c-4-15.5-8.7-30.7-10.4-46.8
                    c-1.4-12.9-1.7-25.7-1-38.6c0.3-5.2,1.5-10.3,2-15.5c2.4-23.5,7.3-46.4,13.2-69.1c2.5-9.5,4.5-19.2,7.1-28.7
                    c1.6-5.8,2.7-12,4.7-17.5c3.3-8.9,2.5-18,3.6-27c0.8-6.8,0.9-13.8,0.9-20.7c0-11.8-1.4-23.5-4.1-34.9c-3-12.7-5.5-25.5-9.3-37.9
                    c-6-19.5-12.2-39-19.8-57.9c-4.5-11.1-9.3-22.2-11.5-34.3c-2.1-11.4-4.6-22.6-4.3-34.3c0.2-7.5-0.4-15-0.3-22.4
                    c0.1-10.1,1.6-19.9,5-29.5c5.6-16.1,10.4-32.5,14.9-49c1.8-6.7,1.6-14.1,2.5-21.1c1.1-8.6-0.5-17.1-0.4-25.7
                    c0.2-10.4-1.8-20.4-3-30.6c-0.3-2.2-1.3-4.2-2-6.3c-0.3-0.9-0.8-1.7-0.9-2.6c-0.8-11.2-6.1-21-9.4-31.4c-3.1-9.8-5.8-19.6-6.2-30
                    c-0.4-8.4-1.6-16.9,0.3-25.2c1.6-7.1,3.5-14.1,5.7-21c1.4-4.6,2.5-9.2,3.3-13.8h-31.5c-0.3,1.1-0.7,2.2-1,3.3
                    c-4,12.3-3.9,25-3.3,37.8c0.6,14.1,4.3,27.5,9,40.7c2.3,6.4,4.4,13,6,19.6c3.4,14.5,6.2,29,6.8,44.1c0.5,14.7,0.5,29.2-2.7,43.5
                    c-2.4,10.9-5.9,21.5-9.2,32.1c-4.2,13.6-10.3,26.7-11.1,41.3c-0.3,5.8-0.5,11.6-0.4,17.3c0.1,9.2-0.1,18.4,0.9,27.4
                    c1,9.1,2.4,18.2,5,26.9c3.9,13.3,9,26.3,13.6,39.4c2.9,8.2,5.4,16.6,8.4,24.8c5.8,15.6,10.4,31.6,14.5,47.7
                    c4.8,18.6,7.9,37.6,7.2,57c-0.3,9.9-0.9,19.8-2.6,29.5c-2,11.7-5.3,23.2-8,34.7c-4.9,20.9-9.8,41.7-14.5,62.6
                    c-1.4,6.1-1.7,12.5-2.6,18.8c-0.9,6.1-2.4,12.1-3,18.1c-0.8,8.5-1.6,17.1-1.4,25.6c0.2,10.6,0.8,21.3,2.5,31.8
                    c1.6,10.1,4.5,19.9,7.1,29.8c3.1,11.7,6.7,23.2,9.6,34.9c4.2,16.6,5.2,33.5,4.6,50.6c-0.3,10.1-1.4,20.1-4.3,29.8
                    c-1.9,6.2-2.9,12.7-4.6,18.9c-1.3,4.6-3.4,9-4.9,13.6c-3.6,11.3-7.1,22.6-10.4,34.1c-2.2,7.5-3.8,15.1-5.8,22.7
                    c-3.9,14.9-5.4,30.1-6.2,45.4c-0.7,13.8-1.1,27.6-1.2,41.4c-0.1,11.3,2.1,22.3,4.2,33.3c1,4.9,1.8,9.9,3.1,14.7
                    c3.5,12.7,6.7,25.7,11.2,38c5.3,14.5,9.9,29.1,13.4,44.2c1.2,5.2,2,10.6,2.6,16c1.2,10.2,2.9,20.4,1.1,30.7
                    c-1.6,8.9-2.5,17.9-5.5,26.6c-4.1,11.7-7.7,23.7-11.4,35.5c-5.8,18.5-9,37.3-6.7,56.8c0.7,6.2,2.4,12.4,4.4,18.4
                    c4.7,14.3,8.7,28.9,11.6,43.6c3.5,17.4,6,34.9,4.2,52.9c-1.3,13-1.3,26.1-2.6,39.1c-1.3,13.4-3.8,26.6-5.4,39.9
                    c-2.6,21.8-4.3,43.7-2.4,65.6h26C885.1,1597.7,884.9,1594.9,884.9,1592.1z"
				/>
				<path
					class="st5"
					d="M823.2,1590.3c0.9-2.1,0.4-4.8,0.8-7.2c1.7-9.7,3.5-19.5,5.4-29.1c1.8-8.9,3.7-17.8,5.8-26.6
                    c2.2-9.4,4.9-18.7,7-28.1c1.5-6.7,1.2-13.8,4.4-20.1c0.2-0.3,0.2-0.7,0.2-1.1c-0.3-9.3-0.7-18.6-1.1-27.9c-0.1-3,0.4-6.1-0.4-8.8
                    c-2.5-9-5.3-18-8.5-26.9c-1.5-4.3-4.2-8.1-6.1-12.2c-4.1-9.2-8.7-18.3-11.9-27.8c-1.8-5.4-4.1-10.9-4-17c0-4-1.2-8.1-2.2-12
                    c-3.4-14.6-3.9-29.5-4-44.5c-0.1-13.7,5.2-25.8,8-38.6c5.8-9.5,7.2-20.5,10.3-31c5.5-18.8,7.1-38.1,6-57.6
                    c-0.6-9.7-1.5-19.4-3.3-28.8c-1.5-8.2-4.4-16.1-6.8-24.1c-2.7-9-5.4-18.1-8.6-26.9c-4.4-12.3-5.9-25.3-8.3-38.1
                    c-1.5-7.8-1.2-16-1.5-24c-0.2-7.8-0.2-15.6,0.2-23.4c0.3-5.9,1.2-11.8,2-17.7c0.6-4.6,1.2-9.3,2.3-13.8c1.6-6.5,3.4-13,5.5-19.3
                    c3.9-11.6,8.5-23,12.1-34.7c3.7-12.4,6.9-25.1,9.6-37.8c1.6-7.5,2.4-15.4,2.6-23.1c0.2-7-0.8-14.1-1.6-21.1
                    c-0.9-7.8-1.9-15.5-3.2-23.2c-2.1-12.5-4.3-24.9-6.8-37.3c-4.9-24.4-7.6-49.1-6.5-74.1c1.1-23.5,3.5-46.9,6.9-70.2
                    c2-13.1,3.1-26.3,4.8-39.4c0.9-7.4,2.2-14.7,3.2-22c2.4-17.4,4.5-34.7,5.4-52.3c1-19.5,0.8-38.9,0.5-58.3
                    c-0.2-14.8-1.6-29.5-4.8-43.9c-3-13.6-5.8-27.3-9.1-40.9c-3.5-13.9-7.5-27.6-11.3-41.3c-5.1-18.6-8.1-37.4-7.8-56.8
                    c0.2-15.5,2.9-30.4,5.7-45.4c3.3-17.7,7.2-35.4,8-53.5c0.4-9.1,1-18.3,0.4-27.3c-0.7-10.4-2.2-20.8-3.9-31
                    c-1.8-10.8-4-21.6-6.7-32.3c-2.3-9-5.8-17.6-8.3-26.6c-2.7-9.7-2.2-19.6,0.4-29.3c2-7.2,4.6-14.1,6.5-21.3
                    c1.2-4.7,2.4-9.4,3.1-14.2h-31.8c-1.8,6.9-3.8,13.7-5.7,20.5c-3.7,13.2-4.1,26.5-0.2,39.8c3.9,13.6,8.3,27.1,11.6,40.8
                    c4.2,17.4,6,35.3,6,53.3c0.1,13.9-0.8,27.7-3.1,41.4c-2.8,16.7-6,33.4-8.9,50.2c-3,17.1-2.9,34.2-1.2,51.4
                    c1.8,17.8,6.8,34.7,11.4,51.8c3.7,13.5,7.4,26.9,10.6,40.5c2.9,12.1,5.3,24.4,7.5,36.7c3,16.4,3.3,33.1,3.5,49.8
                    c0.1,12-0.3,24-0.8,35.9c-0.7,18.5-2.6,36.9-5.4,55.2c-2.3,14.9-4,30-5.9,45c-2.6,21.1-5.5,42.3-7.6,63.5
                    c-2,20.5-3.1,41.1-1.1,61.6c1.4,14.5,3.7,28.9,6.1,43.3c4.2,24.5,9.7,48.7,11.3,73.6c1,16.3-0.8,32.6-5.6,48.2
                    c-5.8,18.8-12.3,37.4-18.4,56.2c-4.9,14.9-7.5,30.4-8.9,46.1c-0.2,2-0.5,4.1-0.6,6.1c-1.2,22.9,0.9,45.5,5.4,67.9
                    c3,14.9,7.8,29.1,12.5,43.4c8.2,25,12.7,50.6,10.7,77.2c-0.9,12.1-2.7,24.1-6.1,35.8c-4.3,14.8-8.8,29.6-12.8,44.5
                    c-4.7,17.4-6.9,35.2-3.7,53.2c3.7,21.2,8.9,41.9,16.7,61.9c5,12.8,10.7,25.2,15.2,38.2c5.6,16.2,7.2,33,5.2,50.3
                    c-2.1,17.5-6,34.5-10.3,51.5c-4.2,17-7.6,34.2-10.2,51.6c-0.7,4.8-1.1,9.6-1.1,14.4h23.2C821.5,1597.1,821.8,1593.7,823.2,1590.3z
                    "
				/>
				<path
					class="st5"
					d="M920.7,1580.3c2.5-12.2,5.3-24.4,7.9-36.6c0.8-3.6,1-7.8,2.8-10.8c2.3-3.8,2.9-7.9,3.7-12.1
                    c2-10.1,4-20.1,5.9-30.2c1.8-9.1,3.7-18.2,5.2-27.4c3.5-21.1,1.2-41.8-4.5-62.1c-4.7-16.5-9.9-32.8-15.1-49.1
                    c-5.8-17.8-8.2-35.9-4.3-54.5c1-4.9,2.3-9.7,3.7-14.5c1.6-5.7,3-11.6,5.3-17c6.9-16.4,10.5-33.5,11.4-51.4
                    c0.9-17.3-0.2-34.3-3.4-51.2c-1-5.1-2.2-10.2-3.2-15.3c-2.5-12.6-5.3-25.2-7.5-37.8c-1.6-9.3-2.8-18.8-3.7-28.2
                    c-0.6-6.1-0.4-12.3-0.3-18.4c0.1-6.2,0.1-12.4,0.8-18.5c2.2-17.2,5.3-34.3,10.7-50.8c3.9-12,7.6-24.1,11.3-36.1
                    c2.7-8.9,5.5-17.7,7.9-26.7c2.9-11.2,5.1-22.5,5.5-34.2c0-0.7-0.1-1.7,0.3-2.2c2.4-3.3,1.7-7.2,1.8-10.8c0.3-7.4,0-14.8-1-22.2
                    c-1.6-11.8-2.4-23.7-5.2-35.3c-2.9-12.3-5.9-24.6-8.9-36.9c-3.7-15.3-8.7-30.3-11.3-46c-3.2-19-5.6-38.1-4.8-57.4
                    c0.5-12.7,1.3-25.4,4.1-37.8c1.4-6.5,3.2-13,4.7-19.5c2.6-11.2,5.1-22.5,7.7-33.8c4-16.7,6.9-33.7,6.8-50.9
                    c0-10.6-1.1-21.2-2-31.8c-0.9-10.2-2.2-20.4-3.5-30.6c-1.6-12.6-4.4-24.9-7.8-37.1c-3.1-11.3-6.2-22.6-9.2-33.9
                    c-2.1-7.5-4.3-15-6.2-22.6c-2-8.1-3.9-16.3-5.6-24.5c-2.1-10-4.5-20-5.6-30.1c-1.4-13-2.1-26.1-2.3-39.1
                    c-0.2-11.9-0.3-24,1.5-35.8c1.8-12.2,5.9-24.1,9-36.1c1.6-6.3,3.5-12.5,5.2-18.7c2.3-8.8,5.6-17.5,6.3-26.5
                    c1.1-14.5,3.1-28.9,2.5-43.6c-0.6-13.3-3.7-25.9-7.9-38.2c-2.9-8.7-7.4-16.9-11-25.4c-1.1-2.5-2-5.2-2.4-8
                    c-0.9-5.6-1.5-11.4-2.1-17.1c-1.4-13.3,1.2-25.9,5.9-38.3c0.9-2.4,1.7-4.8,2.4-7.3h-31.5c-2.6,12-3,24.3-1.4,36.9
                    c0.8,5.9,2.3,11.7,4.2,17.3c3.3,9.7,6.9,19.2,10.8,28.6c4.9,11.9,7.3,24.2,7.2,37.1c-0.1,16.7-0.8,33.4-4.3,49.7
                    c-2.3,10.7-5.8,21.2-8.9,31.7c-8.9,29.7-13.1,59.9-10.5,91.2c1.3,16.4,2.3,32.9,5.6,49c5.4,26.1,11.8,52,19.4,77.5
                    c2.3,7.8,4.1,15.9,5.8,23.9c4.2,19.5,7.1,39.3,9.4,59.2c1.8,16.1,1.6,32.1,0.1,48.2c-1.6,16.6-5.9,32.6-9.5,48.7
                    c-2.3,10.4-5.3,20.6-7.3,31c-5.1,26.6-6.8,53.4-3.7,80.4c2.2,19.1,5.5,38.1,11,56.5c3.4,11.4,7.1,22.8,9.5,34.5
                    c3.2,15.1,5.6,30.5,7.9,45.8c4.2,28.7,0.4,56.7-7.6,84.2c-4.2,14.4-8.9,28.7-13.6,42.9c-5.3,16.3-8.8,33-11.8,50
                    c-2.4,13.2-2.6,26.4-2.1,39.7c0.6,15.2,2.4,30.2,5.5,45c3.3,15.5,6.8,31,9.6,46.5c3.9,21.2,5.6,42.7,2.1,64.2
                    c-2,12.1-4.6,24.2-9.1,35.6c-4.6,11.6-7.8,23.6-9.9,36c-0.9,5.6-0.2,11.6-0.2,17.4c0,20.1,5.3,39.1,11.5,57.9
                    c5.1,15.5,10.7,31,13.2,47.3c2.2,13.7,3.5,27.4,1,41.3c-1.9,10.8-2.9,21.8-4.5,32.7c-0.5,3.5-1.5,6.9-2.2,10.3
                    c-1.5,7.1-2.9,14.2-4.5,21.3c-3.8,17.5-7.8,35-11.6,52.4c-1.9,8.6-3.3,17.6-0.8,26.1c0.3,0.9,0.5,1.8,0.7,2.7h17.6
                    C919,1593.8,919.3,1587.1,920.7,1580.3z"
				/>
				<path
					class="st5"
					d="M771.5,1546.7c1.4-8.1,2.3-16.2,3.5-24.3c0.9-5.9,2.1-11.7,3.2-17.5c2-10.6,3.6-21.2,3-32.1
                    c-0.6-11-0.6-22.1-1.5-33.1c-0.5-6.5-1.7-13.1-3.8-19.1c-2.9-8.2-7-15.8-10.5-23.7c-2.7-6.1-6.1-12-7.6-18.4
                    c-1.3-5.7-5.6-10.3-5-16.7c0.2-1.8-1.6-3.6-2.1-5.6c-3.1-12.9-4.7-26-3.2-39.4c0.7-6.5,0.8-13.1,2.2-19.4c2.6-11.4,5.9-22.7,9-34
                    c1.4-5.2,2.9-10.3,4.5-15.4c1.4-4.6,3.5-8.9,4.6-13.6c3.9-18,7.4-36.1,9.7-54.6c1.1-9.4,1.7-18.6,1.3-27.9
                    c-0.5-11.4-2.1-22.7-5.1-33.7c-3.1-11.6-6.4-23.2-9.8-34.8c-0.9-3-2.4-5.8-3.2-8.9c-1.2-4.5-1.8-9.1-2.9-13.6
                    c-3.1-12.5-5.7-25.2-5.8-38c-0.1-10.6,1.5-21.2,2.4-31.8c0.3-3.7,0.7-7.4,1.2-11.1c0.3-2,0.8-4,1.3-6c0.3-1.4,0.6-2.9,1-4.3
                    c0.5-1.9,1-3.8,1.5-5.7c0.2-0.9,0.6-1.8,0.7-2.7c1.8-13.3,7.2-25.5,9.7-38.7c1.3-6.9,3.8-13.5,5.7-20.3c0.3-1,0.1-2.2,0.2-3.3
                    c0.7-4.8,1.4-9.6,2.1-14.3c0.1-0.9,0.3-1.9,0.3-2.8c0-14.5,0.7-29-0.7-43.6c-1.7-16.9-5.8-33-10-49.2c-3.5-13.7-6.5-27.5-8.6-41.5
                    c-1.8-12.2-3.9-24.4-2.9-36.8c1-13.4,2.1-26.9,4.6-40.1c3.7-20.2,8.8-40,12.8-60.1c4.9-24.7,10.9-49.1,13.7-74.3
                    c1.8-16.5,2.4-32.9-0.8-49.1c-1.8-9.5-4.7-18.8-7.8-27.9c-3.6-10.7-8-21.2-12.1-31.7c-5.2-13.3-10.7-26.4-15.8-39.7
                    c-5.1-13.1-9.4-26.6-11.1-40.7c-1.3-11.5-2.8-23-3.5-34.5c-0.4-6.8,0.1-13.8,0.9-20.7c1.5-12.2,3.3-24.3,5.3-36.4
                    c0.8-5.1,2.4-10.1,3.6-15.2c3.1-13.2,6.1-26.4,9.2-39.5c3-13,5.2-26.3,5.7-39.7c0.3-7.7-0.6-15.7-2.2-23.3
                    c-3.1-15.1-6-30.4-10.8-45c-5.9-17.5-8-35.6-11-53.6c-1.7-10.4,1.6-20,5.8-29.2c1.6-3.4,3.1-6.9,4.6-10.3h-35
                    c-3.1,10.5-4,21.3-1.9,32.6c2.9,14.8,5.2,29.8,8.4,44.6c3,14,7,27.8,10.3,41.8c1.5,6.1,2.5,12.4,3.2,18.7c0.5,4.6,0.4,9.3,0.1,14
                    c-0.6,10.8-2.2,21.5-4.6,32.1c-3.2,13.9-5.7,28.1-9.8,41.8c-4,13.2-5.6,26.9-7.8,40.4c-2.9,17.7-2.8,35.7-0.8,53.6
                    c0.7,6.1,1.4,12.3,2.2,18.3c2.4,16.2,7.3,31.6,13.1,46.7c6.6,17.3,13.8,34.4,20.7,51.7c8.5,21.5,14.6,43.8,14.6,67.4
                    c0,7.8-1.5,15.7-1.2,23.5c0.3,9.1-3.3,17.4-3.8,26.4c-0.3,5.2-2.6,10.3-3.8,15.5c-4,17.7-8.1,35.4-11.8,53.2
                    c-3.5,16.8-6.7,33.6-9.6,50.5c-3,17.7-3.7,35.6-1.5,53.6c2.6,20.2,6.5,40.1,12,59.7c6.7,23.8,10.1,48.2,9.6,73.1
                    c-0.3,16.1-2.5,32-6.6,47.6c-2.9,10.8-4.6,22-8.3,32.5c-5.6,15.9-8,32.5-10.7,49.1c-1.9,11.5-2.6,23.1-1.4,34.7
                    c0.9,9.2,2.6,18.5,4.8,27.5c4.9,19.9,10.5,39.6,15.5,59.5c4.3,17.3,6.2,34.8,5.5,52.8c-1.3,31.9-8.3,62.5-16.7,92.9
                    c-3.4,12.2-7.4,24.3-9.5,36.7c-4.3,25.6-3.1,51.1,4.8,75.9c2.8,8.8,6.4,17.4,10.1,25.9c7.9,17.7,12.8,36.3,15.1,55.8
                    c2.5,21.4,0.7,42.5-2.7,63.7c-2.4,14.7-4.3,29.6-6.1,44.4c-1.4,12.3-0.5,24.7,1.7,36.9c0.3,1.9,0.7,3.8,1.1,5.7h26
                    C769.2,1582.7,768.4,1564.8,771.5,1546.7z"
				/>
				<path
					class="st5"
					d="M713.4,1592c-2.9-9-6-17.9-8.9-26.9c-4.3-13.2-6.8-26.7-4.5-40.7c1.8-11,3.7-22.1,5.9-33
                    c1-4.9,2.8-9.5,4.2-14.3c0.5-1.6,0.7-3.3,0.8-5c0.4-8,0.6-16.1,1.1-24.1c0.8-13.8-1.9-27.2-4.8-40.5c-3.1-13.8-8.8-26.4-14.5-39
                    c-8.3-18.4-12.9-37.5-12.3-58c0.3-10.2,2.5-20,5.1-29.7c3.6-13.3,7.4-26.6,10.8-39.9c3.1-11.9,6.3-23.8,7.4-36.1
                    c0.2-2.5,1.7-5,1.9-7.5c0.7-8.3,1.4-16.7,1.7-25c0.2-6.9-0.2-13.8-0.7-20.7c-0.4-6.9-0.9-13.8-1.9-20.6c-1.4-9.6-3-19.2-5.2-28.6
                    c-2-8.9-5-17.5-7.5-26.3c-4.6-15.9-4.8-32.1-2.7-48.4c3.7-29.1,9-57.9,16.5-86.3c6-22.9,11.2-46,13.3-69.8
                    c1.1-12.7,0.5-25.3-2.2-37.8c-2.4-11.1-4.2-22.4-7.3-33.2c-2.6-9.3-6.5-18.1-9.9-27.1c-0.3-0.7-0.7-1.3-0.9-2
                    c-8.4-22.5-12.2-45.5-7.8-69.7c3.6-19.7,8.6-38.9,14.1-58.1c4.6-16.1,9.7-32,14.2-48.1c4.9-17.2,7.9-34.9,9.6-52.8
                    c1.4-15.1-0.9-29.9-4.3-44.5c-2-8.7-4.6-17.2-7-25.8c-3.2-11.7-8.8-22.4-14-33.2c-6.2-12.8-12.9-25.4-18.6-38.4
                    c-4.5-10.3-7.9-21.2-11.7-31.8c-5.9-16.7-6-33.9-5-51.4c1.1-19.8,6-38.7,11.7-57.3c5.2-17,11.4-33.7,17-50.5
                    c6.6-19.7,7.8-39.8,4.4-60.2c-0.8-4.9-2.3-9.7-3.7-14.6c-2-7-3.8-14-6.3-20.8c-5-13.6-10.2-27-15.5-40.4c-3-7.5-4.3-15.3-5.4-23.3
                    c-1.7-12.7,0.1-24.8,4.2-36.8c1.5-4.5,3-9.1,4.4-13.6h-31.6c-0.4,1.2-0.7,2.3-1,3.5c-5.8,19.8-4.6,39.1,2,58.3
                    c6,17.6,12.2,35.1,18.2,52.6c3,8.6,5.4,17.4,6.4,26.6c1.2,11.4,1.4,22.7-1.6,33.9c-2.1,7.9-3.8,15.8-7.1,23.4
                    c-3.4,7.9-5.8,16.4-8.5,24.6c-3.1,9.4-6.3,18.9-9.1,28.4c-3.4,11.3-6.3,22.8-7.8,34.7c-1.4,10.9-2.6,21.9-2.2,32.8
                    c0.5,13.9,1.1,28,5.2,41.5c2.9,9.4,5.2,19.1,9.1,28c6,13.7,13.2,26.8,19.7,40.4c5.1,10.7,11.3,20.8,14.5,32.4c2.4,9,4.7,18,7.1,27
                    c4.9,18,4.9,36.3,2.1,54.5c-2.7,17.4-7.2,34.3-12.1,51.1c-4.9,17-10.3,33.8-14.9,50.9c-4.9,18.3-9.8,36.7-11.5,55.8
                    c-1.3,15.1-0.9,30,2.8,44.7c1.1,4.3,2.2,8.6,3.5,12.8c1.4,4.2,3.2,8.3,4.7,12.5c0.8,2.3,0.6,5.1,1.8,7c3.8,5.7,5.1,12.4,6.7,18.7
                    c3.8,15.4,8.6,30.8,7.7,47.1c-0.2,2.9,1.2,5.9,1,8.8c-0.4,7.8-1.4,15.6-1.9,23.4c-0.7,12.6-3.9,24.7-6.8,36.8
                    c-5.8,24.7-12.7,49-16.4,74.2c-2.4,16.2-5.6,32.3-6.1,48.8c-0.3,9.1-0.6,18.2,2.2,27c0.5,1.6,0.4,3.3,0.6,5
                    c0.2,1.6,0.3,3.3,0.8,4.9c2.2,7.7,4.8,15.2,6.8,22.9c1.3,5,2,10.1,2.9,15.3c1.8,10.5,3.9,20.9,5.1,31.4c1,9.4,1.2,18.9,1.4,28.4
                    c0.4,15.2-1.3,30.3-4.5,45.1c-3.3,15.5-8,30.6-11.9,45.9c-2.1,8.3-4.6,16.6-5.7,25.1c-1.5,11.8-3.1,23.5-2.3,35.6
                    c0.8,12.7,3,24.8,7.2,36.6c3.4,9.8,7.6,19.3,11.6,28.9c12.7,30.2,15.1,61.6,10.2,93.9c-2.3,14.8-5.1,29.4-7.4,44.2
                    c-2.3,14.6-0.4,28.8,4.5,42.4c3.9,11,8.1,21.9,12.3,32.8H716C715.2,1597.6,714.3,1594.8,713.4,1592z"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
	export default {
		name: "IllustrationThree"
	};
</script>

<style lang="scss" scoped>
	.st0 {
		fill: #ffffff;
	}
	.st1 {
		fill: #c6c6c5;
	}
	.st2 {
		fill: #ffecb6;
	}
	.st3 {
		fill: #093d41;
	}
	.st4 {
		fill: #e54033;
	}
	.st5 {
		fill: #eadbad;
	}
	.st6 {
		fill: #71c4ba;
	}
	.st7 {
		fill: none;
	}
	.st8 {
		fill: #78b542;
	}
	.st9 {
		fill: #c6c6c6;
	}
	.st10 {
		fill: #e0e0de;
	}
	.st11 {
		fill: #7f7f7f;
	}
	.st12 {
		fill: #2d2d2d;
	}
	.st13 {
		fill: #919191;
	}
	.st14 {
		fill: #383838;
	}
	.st15 {
		fill: #d8d8d8;
	}
	.st16 {
		fill: #653c16;
	}
	.st17 {
		fill: #f79e1e;
	}
	.st18 {
		fill: none;
		stroke: #00aeef;
		stroke-miterlimit: 10;
	}
	.st19 {
		fill: #e72527;
	}
	.st20 {
		fill: #e12327;
	}
	.st21 {
		fill: #edb7b6;
	}
	.st22 {
		fill: #1c4650;
	}
	.st23 {
		fill: #122d25;
	}
	.st24 {
		opacity: 0.5;
		fill: #653c16;
	}
	.st25 {
		fill: url(#SVGID_1_);
	}
	.st26 {
		fill: #89c544;
	}
	.st27 {
		fill: #ffe0b6;
	}
	.st28 {
		fill: #bababa;
	}
	.st29 {
		fill: #ea7750;
	}
	.st30 {
		opacity: 0.3;
		fill: #e72527;
	}
	.st31 {
		opacity: 0.3;
		fill: #653c16;
	}
	.st32 {
		fill: #2a5861;
	}
	.st33 {
		fill: #f26f79;
	}
	.st34 {
		fill: #eab557;
	}
	.st35 {
		fill: #80c48d;
	}
	.st36 {
		fill: #264720;
	}
	.st37 {
		fill: #52aa82;
	}
	.st38 {
		opacity: 0.3;
	}
	.st39 {
		fill: #895b24;
	}
	.st40 {
		filter: url(#Adobe_OpacityMaskFilter);
	}
	.st41 {
		mask: url(#SVGID_2_);
	}
	.st42 {
		opacity: 0.3;
		fill: #895b24;
	}
	.st43 {
		fill: #ee7928;
	}
	.st44 {
		fill: #caab82;
	}
	.st45 {
		fill: #e5e5e5;
	}
	.st46 {
		fill: #f69fa1;
	}
	.st47 {
		clip-path: url(#SVGID_4_);
		fill: #fcb017;
	}
	.st48 {
		fill: #727579;
	}
	.st49 {
		fill: #1d2036;
	}
	.st50 {
		fill: #c2c4c4;
	}
	.st51 {
		fill: #6c7d7f;
	}
	.st52 {
		fill: #e9d1b3;
	}
	.st53 {
		fill: #b8d3c7;
	}
	.st54 {
		fill: #abb2b2;
	}
	.st55 {
		fill: #ea3056;
	}
	.st56 {
		fill: #478689;
	}
	.st57 {
		fill: #e2c588;
	}
	.st58 {
		fill: #757576;
	}
</style>
